import { AbstractLayer } from './abstract-layer';
import { ContextData } from 'src/app/data/context.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TextLayerData } from 'src/app/data/configurator/layer/text-layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';

declare const fabric: any;

export class TextLayer extends AbstractLayer {


  /**
   * Contructor
   */
  constructor(data: LayerData, stage: any) {
    super(data, stage);
  }

  /**
   * Draw
   */
  protected _draw(): any {

    this._display = new fabric.IText((<TextLayerData>this._data).text, {
      fontSize: 100,
    });

    this._preview = new fabric.IText((<TextLayerData>this._data).text, {
      fontSize: 100,
    });

    super._draw();

    this._display.setControlsVisibility({
      mb: false,
      ml: false,
      mr: false,
      mt: false,
    });
  }

  /**
   * Update view
   */

  getTextAnchorFromAlign(align:string):string{
    switch (align) {
      case 'left':
        return 'left';
      case 'center':
        return 'middle';
      case 'right':
        return 'right';

      default:
        break;
    }
  }

  updateView(): void {

    this._display.angle = this._currentCanvasAngle + this._data.rotation;
    this._preview.angle = this._data.rotation;

    if (this._display.isEditing) {
      this._display.exitEditing();
    }

    this._display.set({
      fill: (<TextLayerData>this._data).color,
      width: (<TextLayerData>this._data).width,
      fontFamily: (<TextLayerData>this._data).font,
      fontWeight: (<TextLayerData>this._data).bold ? 'bold' : 'normal',
      fontStyle: (<TextLayerData>this._data).italic ? 'italic' : 'normal',
      underline: (<TextLayerData>this._data).underline,
      textAlign: (<TextLayerData>this._data).align,
      scaleX: (<TextLayerData>this._data).size * ContextData.POINTS_TO_PIXELS / 100,
      scaleY: (<TextLayerData>this._data).size * ContextData.POINTS_TO_PIXELS / 100,
      lineHeight: Math.max((<TextLayerData>this._data).leading / 25 + 1, 0.0001)
    });


    this._preview.set({
      fill: (<TextLayerData>this._data).color,
      width: (<TextLayerData>this._data).width,
      fontFamily: (<TextLayerData>this._data).font,
      fontWeight: (<TextLayerData>this._data).bold ? 'bold' : 'normal',
      fontStyle: (<TextLayerData>this._data).italic ? 'italic' : 'normal',
      underline: (<TextLayerData>this._data).underline,
      textAlign: (<TextLayerData>this._data).align,
      scaleX: (<TextLayerData>this._data).size * ContextData.POINTS_TO_PIXELS / 100,
      scaleY: (<TextLayerData>this._data).size * ContextData.POINTS_TO_PIXELS / 100,
      lineHeight: Math.max((<TextLayerData>this._data).leading / 25 + 1, 0.0001)
    });

    this.updatePosition();
    // console.log(this._display);

  }

  /**
   * Update data
   */
  updateData(object: any): void {

    let textData = {
      x: (<TextLayerData>this._data).x,
      y: (<TextLayerData>this._data).y,
      rotation: (<TextLayerData>this._data).rotation,
      font: (<TextLayerData>this._data).font,
      size: (<TextLayerData>this._data).size,
      bold: (<TextLayerData>this._data).bold,
      italic: (<TextLayerData>this._data).italic,
      underline: (<TextLayerData>this._data).underline,
      align: (<TextLayerData>this._data).align,
      leading: (<TextLayerData>this._data).leading,
      // text: (<TextLayerData>this._data).text
    };
    HistoryData.add(this._labelData, this._data, CommandData.SET_STYLE, textData);

    (<TextLayerData>this._data).size = object.scaleX / ContextData.POINTS_TO_PIXELS * 100;
    (<TextLayerData>this._data).text = object.text;

    this._preview.set('text', (<TextLayerData>this._data).text);

    super.updateData(object);
  }

  /**
   * Cleanup
   */
  public cleanup(): void {

  }
}
